export default __webpack_public_path__ + "static/media/cactus.592b40e5.svg";